const component = "select-site-section-perimeter";

export const selectSiteSectionPerimeter = {
  component,
  triggerButton: `${component}/trigger-button`,
  triggerButtonText: `${component}/trigger-button/text`,
  triggerButtonAngleIcon: `${component}/trigger-button/angle-icon`,
  searchSectionInputText: `${component}/search-section-input-text`,
  cancelButton: `${component}/cancel-button`,
  submitButton: `${component}/submit-button`,
};
